import React from 'react';
import { useTranslation } from 'react-i18next';
import { Mail, MapPin } from 'lucide-react';
import { Page } from '../types';

interface FooterProps {
  onNavigate?: (page: Page) => void;
}

export const Footer: React.FC<FooterProps> = ({ onNavigate }) => {
  const { t } = useTranslation();

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    if (onNavigate) {
      onNavigate('contact');
      window.scrollTo(0, 0);
    }
  };

  return (
    <footer id="footer" className="bg-clever-navy text-gray-400 border-t border-gray-800 pt-20 pb-12">
      <div className="max-w-7xl mx-auto px-6">

        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="md:col-span-2">
            <div className="flex flex-col mb-6">
              <div className="flex items-center gap-3 mb-4">
                <img src="/assets/CleverDigital_dark_logo_only.png" alt="CleverDigital" className="h-12 w-auto object-contain" />
              </div>
            </div>
            <p className="text-gray-500 text-sm max-w-xs leading-relaxed mb-6">
              {t('footer.tagline')}
            </p>
          </div>

          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-6">{t('footer.legal')}</h4>
            <ul className="space-y-3 text-sm">
              <li><a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('impressum'); window.scrollTo(0, 0); }} className="hover:text-clever-teal transition-colors">{t('footer.impressum')}</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('privacy'); window.scrollTo(0, 0); }} className="hover:text-clever-teal transition-colors">{t('footer.privacy')}</a></li>
              <li><a href="#" onClick={(e) => { e.preventDefault(); onNavigate?.('agb'); window.scrollTo(0, 0); }} className="hover:text-clever-teal transition-colors">{t('footer.agb')}</a></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white text-xs font-bold uppercase tracking-wider mb-6">{t('footer.contact')}</h4>
            <ul className="space-y-4 text-sm">
              <li className="flex items-center gap-3">
                <MapPin size={16} className="text-gray-600" />
                <span style={{ whiteSpace: 'pre-line' }}>{t('footer.address')}</span>
              </li>
              <li className="flex items-center gap-3">
                <Mail size={16} className="text-gray-600" />
                <a href="mailto:office@cleverdigital.at" className="hover:text-clever-teal transition-colors">office@cleverdigital.at</a>
              </li>
              <li>
                <a href="#" onClick={handleContactClick} className="text-white hover:text-clever-teal transition-colors font-medium flex items-center gap-2 mt-4">
                  {t('footer.contact_link')} <span className="text-clever-teal">→</span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 text-center text-[10px] text-gray-600 uppercase tracking-widest font-medium">
          {t('footer.copyright')}
        </div>

      </div>
    </footer>
  );
};
